<template>
		<v-row>
			<v-col lg="3" md="12" sm="12" xs="12">
				<v-card class="searchForm">
					<v-form class="container">
						<h3>Factory Disclosure Search</h3>
						<v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
							<template v-slot:activator="{ on }">
								<v-text-field :value="computedStartDate" clearable label="Start Date" readonly v-on="on" @click:clear="startDate = null"></v-text-field>
							</template>
							<v-date-picker v-model="startDate" type="month" min="1994-01-01" :max="endOfYear" @change="menu1 = false"></v-date-picker>
						</v-menu>
						<v-menu v-model="menu2" :close-on-content-click="false" max-width="290">
							<template v-slot:activator="{ on }">
								<v-text-field :value="computedEndDate" clearable label="End Date" readonly v-on="on" @click:clear="endDate = null"></v-text-field>
							</template>
							<v-date-picker v-model="endDate" type="month" min="1994-01-01" :max="endOfYear" @change="menu2 = false"></v-date-picker>
						</v-menu>
						<v-divider></v-divider>
						<v-autocomplete v-model="school" item-text="name" item-value="id" style="clear: both" label="School" :items="schools" multiple chips clearable deletable-chips />
						<v-autocomplete v-model="licensee" item-text="name" item-value="id" label="Licensee" :items="licensees" multiple chips clearable deletable-chips />
						<v-autocomplete v-model="country" item-text="name" item-value="id" label="Country" :items="countries" multiple chips clearable deletable-chips />
						<v-text-field v-model="factory"	label="Factory"></v-text-field>
						<v-select v-model="aggregate" label="Group By" :items="aggregates" default chips clearable deletable-chips />

						<div class="text-center">
							<v-btn color="secondary" class="ma-2" @click="clearSearch()">Reset</v-btn>

							<v-btn color="primary" class="ma-2" :disabled="!formIsValid || currentlySearching" @click="searchAll()">Search</v-btn>
						</div>
						<v-banner v-if="!dateRangeIsValid">
								Start Date must occur before end date.
						</v-banner>
						<v-banner v-if="!criteriaIsValid">
							Please select a School, Licensee, Country, or Factory search criteria. 
						</v-banner>
				</v-form>
				<v-overlay :value="overlay">
					<v-btn icon	@click="overlay = false">
						<v-progress-circular indeterminate color="primary"></v-progress-circular>
					</v-btn>
				</v-overlay>
			</v-card>
			</v-col>
			<v-col lg="9" md="12" sm="12" xs="12">
				<template v-if="!aggregate">
					<ResultSetCards :results="results" :page="page" v-on:export-data="exportData()" />
					<v-snackbar :timeout="0" v-model="showCount"> Retrieved {{ count }} records so far... <v-btn color="primary" @click="forceHalt = true">Stop</v-btn></v-snackbar>
				</template>

				<template v-else>
					<ResultSetCards :results="aggregateData" :agg="getAggValue(aggregate)" :page="page" v-on:export-data="exportData()" />
					<v-snackbar :timeout="0" v-model="showCount"> Retrieved {{ count }} records so far... <v-btn color="primary" @click="forceHalt = true">Stop</v-btn></v-snackbar>
				</template>
					
			</v-col>
		</v-row>
</template>

<script>
import ResultSetCards from './ResultSetCards.vue';
import moment from 'moment';
import axios from 'axios';
import Papa from 'papaparse';
import _ from 'lodash';



var API_URL = 'https://jejlaul3j6.execute-api.us-east-1.amazonaws.com/latest';

export default {
	name: 'DatabaseSearch',
	components: {
		ResultSetCards
	},
	data: () => ({
			overlay: false,
			school: null,
			licensee: null,
			country: null,
			factory: null,
			aggregate: 'Factory',
			startDate: null, //(new Date('2019-01-01')).toISOString().substr(0, 10),
			endDate: null, //(new Date('2019-03-31')).toISOString().substr(0, 10),
			menu1: false,
			menu2: false,
			currentPeriodStart: null,
			currentPeriodEnd: null,
			results: [],
			countries: [],
			licensees: [],
			schools: [],
			aggregates: ['School', 'Country','Licensee', 'Factory'],
			page: 1,
			sortBy: 'School',
			showCount: false,
			count: 0,
			forceHalt: false,
			currentlySearching: false
	}),
	watch: {
		startDate: function () {
			if (this.formIsValid)
				this.loadDropDowns();
		},
		endDate: function () {
			if (this.formIsValid)
			this.loadDropDowns();
		}
	},
	computed: {
		computedEndDate () {
			return this.endDate ? moment(this.endDate).format('MMMM YYYY') : '';
		},
		computedStartDate () {
			return this.startDate ? moment(this.startDate).format('MMMM YYYY') : '';
		},
		formIsValid () {
			return (this.endDate > this.startDate) && (this.school || this.licensee || this.country || this.factory || this.aggregate);
		},
		dateRangeIsValid () {
			return (this.endDate > this.startDate);
		},
		criteriaIsValid () {
			return (this.school || this.licensee || this.country || this.factory);
		},
		endOfYear () {
			return moment().endOf('year').toISOString();
		},
		aggregateData () {
				let agg = this.getAggValue(this.aggregate)
				let grouper =_.chain(this.results)
					.groupBy(agg)
					.value()
			
				let output = [];

				for (let a in grouper){
					let set = grouper[a],
						reduced = {};
					set.forEach(x => {
							for (let y in x) {
								if (!reduced[y])
									reduced[y] = [];
								reduced[y].push(x[y]);
						}
					})
				output.push(reduced);
				}
			console.log(this.results)
			console.log(output)
			return output
			
		}
			
			

		
	},
	created: function () {
		return axios.get(`${API_URL}/config`)
			.then(resp => {
				let end = (new Date(resp.data.data.disclosure_end)).toISOString().substr(0, 10),
						start = (new Date(resp.data.data.disclosure_begin)).toISOString().substr(0, 10);
				this.endDate = end;
				this.startDate = start;
				this.currentPeriodEnd = end;
				this.currentPeriodStart = start;
				return this.loadDropDowns();
			});
	},
	methods: {
		loadDropDowns: function () {
			let query = encodeURIComponent(`{ "startDate": "${this.startDate}", "endDate": "${this.endDate}"}`);
			return Promise.all([
				axios.get(`${API_URL}/countries?query=${query}`)
					.then(result => {
						this.countries = result.data.data;
					}),
				axios.get(`${API_URL}/schools?query=${query}`)
					.then(result => {
						this.schools = result.data.data;
					}),
				axios.get(`${API_URL}/licensees?query=${query}`)
					.then(result => {
						this.licensees = result.data.data;
					}),
			])
			.catch(err => {
				alert(err);
			});
		},
		exportData: function () {
			let data = Papa.unparse(this.results),
					blob = new Blob([data], {type: 'text/csv'}),
					filename = 'results.csv';

			if (navigator.msSaveBlob) {
				navigator.msSaveBlob(blob, filename);
				return;
			}

			let lnk = document.createElement('a'),
					url = window.URL,
					objectURL;

			lnk.type = 'text/csv';

			lnk.download = filename || 'untitled';
			lnk.href = objectURL = url.createObjectURL(blob);
			lnk.dispatchEvent(new MouseEvent('click'));
			setTimeout(url.revokeObjectURL.bind(url, objectURL));
		},
		clearSearch: function () {
			this.school = [];
			this.licensee = [];
			this.country = [];
			this.factory = "";
			this.startDate = this.currentPeriodStart;
			this.endDate = this.currentPeriodEnd;
		},
		searchAll: function () {
			this.overlay = true;
			this.currentlySearching = true;
			this.results = [];
			let payload = { schools: this.school,
							licensees: this.licensee,
							countries: this.country,
							factories: this.factory,
							startDate: this.startDate,
							endDate: this.endDate,
							offset: 0 },
			
					updatePill = (number) => {
						this.overlay = false;
						this.showCount = true;
						this.count = number;
					},
					getAllResults = () => {
						return axios.get(`${API_URL}/search?query=` + encodeURIComponent(JSON.stringify(payload)))
									.then(results => {
										this.results = this.results.concat(results.data.data);

										if (this.forceHalt) {
											this.forceHalt = false;
											console.log(this.results)
											return;
										}
										if (results.data.data.length == 1000) {
											updatePill(this.results.length);
											payload.offset += 1000;
											return getAllResults();
										}
									});
					};
					
					return getAllResults().then(() => { this.showCount = false; this.overlay = false; this.currentlySearching = false; });
		},
		getAggValue: function (agg) {
			if(agg == 'School'){
				return 'SchoolName'
			}else if(agg == 'Country') {
				return 'CountryName'
			} else if(agg == 'Licensee') {
				return 'LicenseeName'
			}else if (agg == 'Factory'){
				return 'FactoryName'
			}
		}
	}
}
</script>
